module.exports = __webpack_public_path__ + "static/media/cover-home-1.b16166d1.jpg";